module.exports = __webpack_public_path__ + "img/無尾巷，有39戶的吊腳樓.fc8dea8c.jpg";